import { Button, ControlledInput, useZodHookForm, VerticalSpacing, z } from '@willow/shared-web';
import { Form } from '@willow/shared-web/bootstrap';

import { authEmailSchema } from '../auth/authFormSchema';
import { Alert } from '../components/alert/Alert';
import {
  CONTINUE,
  EMAIL_FOOTER,
  EMAIL_LABEL,
  FIND_PORTAL_BODY,
  FIND_PORTAL_TITLE,
  LOOKUP_FAILED_SUBTITLE,
  LOOKUP_FAILED_TITLE,
} from './findPortalCopy';
import { FindPortalLayout } from './FindPortalLayout';

import s from './FindPortal.module.scss';

const FormShape = z.object({ email: authEmailSchema });

interface Props {
  email: string;
  lookupFailed: boolean;
  onSubmit: (email: string) => void;
}

export const EmailScreen = ({ email, lookupFailed, onSubmit }: Props) => {
  const { control, handleSubmit } = useZodHookForm(FormShape, { defaultValues: { email } });

  return (
    <FindPortalLayout
      testId="find-portal-screen-email"
      documentTitle={FIND_PORTAL_TITLE}
      title={FIND_PORTAL_TITLE}
      description={FIND_PORTAL_BODY}
    >
      {lookupFailed && (
        <div className="auth-layout__aligned" role="alert" aria-live="assertive">
          <Alert level="ERROR" title={LOOKUP_FAILED_TITLE} subtitle={LOOKUP_FAILED_SUBTITLE} />
        </div>
      )}

      <Form onSubmit={handleSubmit((data) => onSubmit(data.email))} noValidate>
        <VerticalSpacing spacing={2}>
          <Form.Group controlId="email">
            <ControlledInput
              control={control}
              fieldName="email"
              label={EMAIL_LABEL}
              inputType="email"
              autoComplete="email"
              inputMode="email"
              autoCapitalize="none"
              spellCheck={false}
              autoFocus
            />
          </Form.Group>

          <Button
            type="submit"
            size="lg"
            className="w-100"
            innerClassName="justify-content-center"
            data-testid="find-portal-continue"
          >
            {CONTINUE}
          </Button>
        </VerticalSpacing>
      </Form>

      <p className={s.note}>{EMAIL_FOOTER}</p>
    </FindPortalLayout>
  );
};
